module.exports = __webpack_public_path__ + "img/coupon-icon-03.da0b457f.png";